import { useEffect } from 'react';
import { useRouter } from 'src/shared/hooks/useRouting';
import { URL_PATH } from 'src/shared/constants';
import { E_IDENTITY_STATUS } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/CaseInformation/types';
import { SEEN_CASES_PURGE_DELAY_MS } from 'src/ui/views/caseDetails/constants';
var seenCasesCache = new Map();
export var addSeenCase = function (caseId, delayMs) {
    if (delayMs === void 0) { delayMs = SEEN_CASES_PURGE_DELAY_MS; }
    if (!caseId) {
        return;
    }
    var existingEntry = seenCasesCache.get(caseId);
    if (existingEntry === null || existingEntry === void 0 ? void 0 : existingEntry.timerId) {
        clearTimeout(existingEntry.timerId);
    }
    var timerId = setTimeout(function () {
        seenCasesCache.delete(caseId);
    }, delayMs);
    seenCasesCache.set(caseId, {
        timestamp: Date.now(),
        timerId: timerId,
    });
};
export var checkIfCaseIsAlreadySeen = function (caseId, delayMs) {
    if (delayMs === void 0) { delayMs = SEEN_CASES_PURGE_DELAY_MS; }
    if (!caseId) {
        return false;
    }
    var entry = seenCasesCache.get(caseId);
    if (!entry) {
        return false;
    }
    var isExpired = Date.now() - entry.timestamp >= delayMs;
    if (isExpired) {
        if (entry.timerId) {
            clearTimeout(entry.timerId);
        }
        seenCasesCache.delete(caseId);
        return false;
    }
    return true;
};
export var clearSeenCases = function () {
    seenCasesCache.forEach(function (entry) {
        if (entry.timerId) {
            clearTimeout(entry.timerId);
        }
    });
    seenCasesCache.clear();
};
export var getSeenCases = function () {
    var now = Date.now();
    seenCasesCache.forEach(function (entry, id) {
        var isExpired = now - entry.timestamp >= SEEN_CASES_PURGE_DELAY_MS;
        if (isExpired) {
            if (entry.timerId) {
                clearTimeout(entry.timerId);
            }
            seenCasesCache.delete(id);
        }
    });
    var activeCaseIds = Array.from(seenCasesCache.keys());
    return activeCaseIds;
};
export var useSeenCases = function (token) {
    useEffect(function () {
        if (token) {
            addSeenCase(token);
        }
    }, [token]);
    return {
        addSeenCase: addSeenCase,
        checkIfCaseIsAlreadySeen: checkIfCaseIsAlreadySeen,
        clearSeenCases: clearSeenCases,
        getSeenCases: getSeenCases,
    };
};
export var useCaseAutoPlayRedirect = function (token, autoPlay, isCaseLoading, applicants, _currentCase) {
    var router = useRouter();
    useSeenCases(token);
    useEffect(function () {
        var hasApplicants = Boolean(applicants === null || applicants === void 0 ? void 0 : applicants.length);
        var shouldCheckApplicants = autoPlay && !isCaseLoading && hasApplicants;
        if (shouldCheckApplicants) {
            var hasIdentitiesToStudy = applicants === null || applicants === void 0 ? void 0 : applicants.some(function (applicant) { return applicant.identityStatus === E_IDENTITY_STATUS.TO_STUDY; });
            var hasNoIdentitiesLeft = !hasIdentitiesToStudy;
            if (hasNoIdentitiesLeft) {
                router.push(URL_PATH.AUTO_SEARCH);
            }
        }
    }, [autoPlay, isCaseLoading, applicants, router]);
};
